import { UserCircle } from 'lucide-react';

import type { RouteListItem } from '@/types';

export const systemUsersSubNav: RouteListItem[] = [
  {
    path: '/system-users/$id',
    icon: UserCircle,
    name: 'System User',
  },
];
